<div class="vc-no-clinics">
  <h2>{{ "CONTEXT.NO_CLINICS_TITLE" | translate }}</h2>
  <p>{{ "CONTEXT.NO_CLINICS_MESSAGE" | translate }}</p>

  @if (isSuperUser) {
    <div class="vc-no-clinics__actions">
      <button type="button" (click)="backToCustomers()">
        {{ "CONTEXT.BACK_TO_CUSTOMERS" | translate }}
      </button>
      <button type="button" (click)="exitActing()">
        {{ "CONTEXT.EXIT_ACTING" | translate }}
      </button>
    </div>
  } @else {
    <button type="button" (click)="logout()">
      {{ "MENU.LOGOUT" | translate }}
    </button>
  }
</div>
